export const outreachBasePath = '/manage/outreaches';
export const outreachDashboardPath = `${outreachBasePath}/dashboard`;
export const outreachCreatePath = `${outreachBasePath}/create`;

export const outreachAggregateReportPath =
  '/reports/outreach/outreach-aggregate';

export const outreachAggregateReportHistoryPath =
  '/reports/outreach/outreach-aggregate/download-history';

export const outreachAggregateReportViewPath =
  '/reports/outreach/outreach-aggregate/view/:id';

export const inventoryBasePath = '/manage/inventory';

export const inventoryDashboardPath = inventoryBasePath;
export const inventoryDownloadRequestsPath = `${inventoryBasePath}/download-requests`;

export const inventoryItemsPath = `${inventoryBasePath}/items`;
export const inventoryCreateItemPath = `${inventoryItemsPath}/create`;
export const inventoryEditItemPath = `${inventoryItemsPath}/:id/edit`;
export const inventoryViewItemPath = `${inventoryItemsPath}/:id/view`;
export const inventoryAdjustItemPath = `${inventoryItemsPath}/:id/adjust`;
export const inventoryItemsAvailabilityPath = `${inventoryItemsPath}/availability`;
export const inventoryItemsAuditLogsPath = `${inventoryItemsPath}/audit-logs`;
export const inventoryItemsImportPath = `${inventoryBasePath}/items/import`;
export const inventoryItemsQauntityImportPath = `${inventoryBasePath}/items-quantity/import`;

export const inventoryPackagesPath = `${inventoryBasePath}/packages`;
export const inventoryCreatePackagePath = `${inventoryPackagesPath}/create`;
export const inventoryEditPackagePath = `${inventoryPackagesPath}/:id/edit`;
export const inventoryViewPackagePath = `${inventoryPackagesPath}/:id/view`;
export const inventoryAdjustPackagePath = `${inventoryPackagesPath}/:id/adjust`;
export const inventoryPackagesAvailabilityPath = `${inventoryPackagesPath}/availability`;

export const inventoryTagsPath = `${inventoryBasePath}/tags`;
export const inventoryCreateTagePath = `${inventoryTagsPath}/create`;
export const inventoryEditTagsPath = `${inventoryTagsPath}/edit/:id`;

export const inventoryLocationsPath = `${inventoryBasePath}/locations`;
export const inventoryCreateLocationPath = `${inventoryLocationsPath}/create`;
export const inventoryEditLocationPath = `${inventoryLocationsPath}/edit/:id`;
export const inventoryViewLocationPath = `${inventoryLocationsPath}/view/:id`;

export const inventoryReportsPath = `${inventoryBasePath}/reports`;
export const inventoryGuestSummaryReportPath = `${inventoryReportsPath}/pos`;
export const inventoryDonorSummaryReportPath = `${inventoryReportsPath}/donor`;
export const inventoryLowStockItemsPath = `${inventoryReportsPath}/low-stock-items`;
export const inventoryOnHandPath = `${inventoryReportsPath}/on-hand`;
export const inventoryItemsAndPackagesSkusPath = `${inventoryReportsPath}/items-and-packages-skus`;

export const storageBasePath = '/manage/storage';
export const storageDashboardPath = storageBasePath;
export const storageListPath = `${storageBasePath}/list`;
export const storageCreatePath = `${storageBasePath}/create`;

export const posBasePath = '/pos';
export const posViewOrderPath = `${posBasePath}/orders/:visitTrackId/view`;

export const reservationsBasePath = '/manage/reservations';
export const reservationsCreatePath = `${reservationsBasePath}/create`;
export const reservationsEditPath = `${reservationsBasePath}/edit/:id`;
export const reservationsViewPath = `${reservationsBasePath}/view/:id`;
export const reservationsOrdersPath = `${reservationsBasePath}/orders/:id`;
export const reservationsTodaysPath = `${reservationsBasePath}/todays`;
export const reservationsUpcomingPath = `${reservationsBasePath}/upcoming`;
export const reservationsPendingPath = `${reservationsBasePath}/pending`;
export const reservationsUpcomingEventsPath = `${reservationsBasePath}/upcoming-events`;
export const reservationsArchivedPath = `${reservationsBasePath}/archived`;

export const reservationsROBase = '/manage/reservations/guest-choices';
export const reservationsROItemListPath = `${reservationsROBase}/items`;
export const reservationsROItemCreatePath = `${reservationsROBase}/items/create`;
export const reservationsROItemEditPath = `${reservationsROBase}/items/edit/:id`;
export const reservationsROItemViewPath = `${reservationsROBase}/items/view/:id`;
export const reservationsROPicklistCreatePath = `${reservationsROBase}/picklists/create`;
export const reservationsROPicklistEditPath = `${reservationsROBase}/picklists/edit/:id`;
export const reservationsROPicklistViewPath = `${reservationsROBase}/picklists/view/:id`;
export const reservationsROPicklistListPath = `${reservationsROBase}/picklists`;
export const reservationsReportsBase = `${reservationsROBase}/reports`;
export const reservationsOrderedItemsReportsPath = `${reservationsReportsBase}/ordered-items`;

export const guestsBasePath = '/manage/guests';
export const guestsCreatePath = `${guestsBasePath}/create`;
export const guestsViewPath = `${guestsBasePath}/view/:id/:section`;
export const guestsMergePath = `${guestsBasePath}/merge/:id`;
export const guestsVisitTrackViewPath = `${guestsBasePath}/view/:id/visits/:visitId/:visitTrackId`;

export const settingsBasePath = '/settings';
export const settingsPortalPath = `${settingsBasePath}/portal`;
export const settingsPortalPantryPath = `${settingsPortalPath}/pantry`;
export const settingsPortalUsersPath = `${settingsPortalPath}/users`;
export const settingsPortalSmtpAccountPath = `${settingsPortalPath}/smtp-account`;

export const settingsPosPath = `${settingsBasePath}/pos`;
export const settingsPosTrackingMethodLocationsPath = `${settingsPosPath}/tracking-method-locations`;
export const settingsPosTrackingMethodLocationsEditPath = `${settingsPosTrackingMethodLocationsPath}/edit/:id`;

export const signaturePadPath = '/react-signature';

export const loginPath = '/login';

export const createNewVisitPath = '/create-new-visit/guest/:guestId';

export const visitHistoryReportPath = '/reports/guests/visit-history';

export const guestReservationPath = '/manage/guest/view/:id';
